import React, { useContext } from "react";
import "./Icon.css";
import { OrderContext } from "../../contexts/OrderContext";

function CartIcon({opener}) {
  const { newItems, setNewItems } = useContext(OrderContext);
  const handleSidebarOpen = () => {
    opener(true);
    setNewItems(false);
  }

  return (
    <div className="side-icon sidenav-icon" onClick={handleSidebarOpen}>
      <div className={`side-icon-border ${newItems ? "trigger-cart-animation" : ""}`} />
      <span className="material-symbols-outlined">
        shopping_cart
      </span>
    </div>
  )
}

export default CartIcon;